import { RootState } from '@reducers';
import { State } from './action';

export const selectCommissionShareList = (state: RootState): State => state.userDashboardRouteReducer.userDashboardCommissionShares;
